export class MsftSmeMock {

    public static strings: any;

    public static selfSpy: jasmine.Spy;
    public static getStringsSpy: jasmine.Spy;

    public static mockStrings(strings: any) {
        MsftSmeMock.strings = strings.Strings;
        MsftSmeMock.getStringsSpy = spyOn(MsftSme, 'getStrings').and.callFake(() => MsftSmeMock.strings);
    }

    public static mockSelf(overrides?: (MsftSme.MsftSmeWindowContext | any)) {
        const mock: MsftSme.MsftSmeWindowContext = {
            Init: {
                mode: 1,
                isProduction: false,
                logLevel: 7,
                sessionExpiration: 0,
                performanceProfile: false,
                developerGuide: false,
                connectivityLevel: '',
                isShell: false,
                shellVersion: '15.2.9',
                gatewayApiVersion: '2.0.0',
                gatewayPlatform: 'Windows'
            },
            Host: {
                isElectron: false,
                isWeb: true
            },
            Environment: {
                name: null,
                displayName: null,
                resources: null,
                origin: null,
                signature: null,
                shell: null,
                entryPoints: null,
                modules: null,
                version: null,
                gatewayApiVersion: null,
                gatewayPlatform: null,
                configuration: {
                    settings: {
                        account: {
                            show: true
                        },
                        personalization: {
                            show: true
                        },
                        diagnostic: {
                            show: true
                        },
                        language: {
                            show: true
                        },
                        notification: {
                            show: true
                        },
                        extension: {
                            show: true
                        },
                        azure: {
                            show: true
                        },
                        access: {
                            show: true
                        },
                        sharedConnections: {
                            show: true
                        },
                        general: {
                            show: true
                        },
                        connectivity: {
                            show: true
                        },
                        updates: {
                            show: true
                        },
                        performance: {
                            show: true
                        },
                        advanced: {
                            show: true
                        }
                    }
                }
            },
            Resources: {
                localeId: 'en-US',
                localeRegionalId: 'en-US',
                strings: MsftSmeMock.strings,
                theme: 'light',
                assets: { css: [], cssV2: [], js: [] },
                moduleAssets: {},
                accessibilityMode: false,
                lib: null
            }
        };
        MsftSme.deepAssign(mock, overrides || {});
        MsftSmeMock.selfSpy = spyOn(MsftSme, 'self').and.callFake(() => mock);
    }
}
